export function formatCurrency(value?: number | string): string {
    if (value === undefined) return '';
    const val = typeof value === 'string' ? parseFloat(value) : value;
    return val.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}
